module.exports = __webpack_public_path__ + "img/0Q3A2940_Mockup.745b30bb.jpg";